module.exports = __webpack_public_path__ + "static/media/chatlogo.ee6d8c3e.png";